import {mapGetters} from 'vuex'
const UserRules = {
  computed: {
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole'])
  },
  methods: {
    //- Can user create stuff on this region ?
    canUserCreate(regionId) {
      if (!regionId) {
        return false
      }
      return Boolean(
        this.currentUserRole !== 'region' ||
          (this.currentUserRole === 'region' && this.currentUser.regionIds.includes(regionId))
      )
    },
    //- Can user create stuff on this region ?
    userAdminAndKanslistCan() {
      return Boolean(
        this.currentUserRole === 'admin' ||
        this.currentUserRole === 'registry'
      )
    },
    //- Can user approve created stuff on this region ?
    canUserApprove(regionId, createdById) {
      if (!regionId || !(this.currentUser && this.currentUser.id)) {
        return false
      }

      return Boolean(
        createdById !== this.currentUser.id &&
          (this.currentUserRole !== 'region' ||
            (this.currentUserRole === 'region' && this.currentUser.regionIds.includes(regionId)))
      )
    }
  }
}
export default UserRules
